import {useMemo} from 'react'

export function useDirection(text) {
  return useMemo(() => {
    let rtlCount = 0;
    let ltrCount = 0;
    if (!text) {
      return 'ltr'; // Default to LTR if no text is provided
    }

    for (const char of text) {
      const code = char.charCodeAt(0);

      // RTL
      if (
        (code >= 0x0590 && code <= 0x08FF) || // Hebrew, Arabic, Syriac, etc.
        (code >= 0xFB1D && code <= 0xFEFC)    // Arabic Presentation Forms
      ) {
        rtlCount++;
      }

      // LTR
      else if (
        (code >= 0x0041 && code <= 0x005A) || // A-Z
        (code >= 0x0061 && code <= 0x007A) || // a-z
        (code >= 0x0370 && code <= 0x052F)    // Greek, Cyrillic
      ) {
        ltrCount++;
      }
    }

    if (rtlCount === 0 && ltrCount === 0) return 'ltr';
    return rtlCount > ltrCount ? 'rtl' : 'ltr';
  }, [text]);
}
